import get from 'transmute/get';
import getIn from 'transmute/getIn';
import { CRM_OBJECT } from '../constants/CrmObjectType';
import { ObjectTypeId } from '../constants/ObjectTypeIds';
import { ObjectRecord } from '../types/ObjectRecord';
import { ObjectType } from '../types/ObjectType';
import { PropertyValueRecordType } from '../types/PropertyValueRecordType';
import {
  BaseObjectRecordContents,
  ObjectRecordFactory,
} from './makeObjectRecord';
import BaseObjectContents from '../objects/BaseObjectContents';

export function getIdKey<T extends Object>(record: ObjectRecord<T>) {
  return record && (record.constructor as ObjectRecordFactory<T>)._idKey;
}

export function getId<T extends Object>(
  record: ObjectRecord<T>
): string | number | undefined | null {
  return (
    record &&
    (getIn((getIdKey(record) || []) as string[], record) as
      | string
      | number
      | undefined
      | null)
  );
}

export function getObjectType<T extends Object>(
  record: ObjectRecord<T>
): ObjectType | ObjectTypeId {
  const objectType =
    record && (record.constructor as ObjectRecordFactory<T>)._objectType;
  return objectType === CRM_OBJECT
    ? // We know that this will return an objectTypeId
      (get('objectTypeId', record)! as unknown as ObjectTypeId)
    : objectType;
}

export function getProperty(
  record: BaseObjectRecordContents | BaseObjectContents,
  property?: string
): string | undefined {
  if (property === undefined) return undefined;
  if (!record) return undefined;
  const propertyValue: any = getIn(['properties', property, 'value'], record);
  if (propertyValue === undefined) return undefined;
  return propertyValue as string;
}

export function getPropertyValue<T extends BaseObjectRecordContents>(
  record: ObjectRecord<T>,
  property?: string
): PropertyValueRecordType | undefined {
  if (property === undefined) return undefined;
  return (
    record &&
    (getIn(['properties', property], record) as PropertyValueRecordType)
  );
}
